<div class="tabs">
  <div
    class="arrow-left"
    (click)="scrollTabs('right')"
    [ngClass]="{ 'arrow-hidden': !leftArrowVisible }"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.537 17.2636C14.8885 17.615 14.8885 18.1849 14.5371 18.5364C14.1856 18.8879 13.6157 18.8879 13.2643 18.5364L7.26364 12.5364C6.91212 12.1849 6.91212 11.6151 7.26364 11.2636L13.2643 5.26357C13.6157 4.91212 14.1856 4.91215 14.5371 5.26364C14.8885 5.61513 14.8885 6.18498 14.537 6.53643L9.17286 11.9L14.537 17.2636Z"
        fill="#0F1F30"
      />
    </svg>
  </div>
  <div class="tab-links" #tabsWrapper>
    <button
      *ngFor="let title of tabTitles()"
      (click)="onTabSelected(title)"
      [class]="tabLinkClass(title)"
    >
      {{ title }}
    </button>
  </div>
  <div
    class="arrow-right"
    (click)="scrollTabs('left')"
    [ngClass]="{ 'arrow-hidden': !rightArrowVisible }"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.26364 17.2636C8.91215 17.615 8.91212 18.1849 9.26358 18.5364C9.61503 18.8879 10.1849 18.8879 10.5364 18.5364L16.537 12.5364C16.8885 12.1849 16.8885 11.6151 16.537 11.2636L10.5364 5.26357C10.1849 4.91212 9.61503 4.91215 9.26358 5.26364C8.91212 5.61513 8.91215 6.18498 9.26364 6.53643L14.6278 11.9L9.26364 17.2636Z"
        fill="#0F1F30"
      />
    </svg>
  </div>
</div>
<ng-content></ng-content>
